import { LOGO_URL } from "./constants";

export const Footer = ({ onArchivedClick }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer" data-testid="landing-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img src={LOGO_URL} alt="KIRA Markets" className="footer-logo" />
          <div>
            <div className="footer-title">
              <span className="brand-silver">KIRA</span>
              <span className="brand-gold">MARKETS</span>
            </div>
            <div className="footer-sub">AI-Powered Stock Research &amp; Market Intelligence</div>
          </div>
        </div>
        <nav className="footer-links" data-testid="footer-links">
          <a href="#features" data-testid="footer-research-notes">Research Notes</a>
          <a href="#features" data-testid="footer-market-watch">Market Watch</a>
          <a href="#archived-research" onClick={onArchivedClick} data-testid="footer-archived">Archived Research</a>
          <a href="/privacy-policy.html" data-testid="footer-privacy">Privacy Policy</a>
          <a href="/terms.html" data-testid="footer-terms">Terms</a>
          <a href="#team" data-testid="footer-contact">Contact</a>
        </nav>
      </div>
      <div className="footer-legal">
        <span>© {year} KIRA Markets. All Rights Reserved.</span>
        <span className="footer-legal-sep">·</span>
        <span>Designed &amp; Developed by <strong>Sabarinadh Palutla</strong></span>
      </div>
    </footer>
  );
};
